import axios from "axios";
import { trim } from "lodash";
import { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import validator from "validator";
import Loader from "../Components/Global/Loader";
import Navbar from "../Components/Layout/Navbar";
import useAxiosFetch from "../hooks/useAxiosFetch";

import useToastify from "../hooks/useToastify";

export default function Register() {
    // show toast hook 
  const { notify } = useToastify();;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [backendmsg, setBackendmsg] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const route = useNavigate();
  const [countryList, setCountryList] = useState();
  const [stateList, setStateList] = useState();
  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();

  const [registerData, setRegisterData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    username: "",
    password: "",
    password_type: "password",
    role: "1",
    confirmPassword: "",
    phone_number: "",
    address: "",
    apartment: "",
    city: "",
    province: "",
    country: "",
    postal_code: "",
    company_name: "",
    payment_details: "",
    confirmPassword_type: "password",
  });

  const {
    first_name,
    middle_name,
    last_name,
    email,
    username,
    password,
    confirmPassword,
    password_type,
    confirmPassword_type,
    phone_number,
    address,
    apartment,
    city,
    province,
    country,
    postal_code,
    company_name,
    payment_details,
  } = registerData;

  const validation = (values) => {
    const errors = {};
    const onlyText = /^[a-zA-Z0-9' . - _ ! $ % @ & # ? : ; ^ ~,/*-]+$/;

    if (!first_name || !trim(first_name)) {
      errors.first_name = "Please enter your first name.";
    } else if (!onlyText.test(first_name)) {
      errors.first_name = "Please enter a valid first name.";
    }

    if (!last_name || !trim(last_name)) {
      errors.last_name = "Please enter your last name.";
    } else if (!onlyText.test(last_name)) {
      errors.last_name = "Please enter a valid last name.";
    }

    if (!username || !trim(username)) {
      errors.username = "Please enter your username.";
    } else if (!onlyText.test(username)) {
      errors.username = "Please enter a valid username.";
    }

    if (!email || !trim(email)) {
      errors.email = "Please enter your email.";
    } else if (!validator.isEmail(email)) {
      errors.email = "Please enter a valid email.";
    }

    if (!password || !trim(password)) {
      errors.password = "Please enter your password.";
    } else if (!onlyText.test(password)) {
      errors.password = "Please enter a valid password.";
    } else if (password.length < 8) {
      errors.password = "Please enter at least 8 characters. ";
    }

    if (!confirmPassword) {
      errors.confirmPassword = "Please enter confirmation password.";
    }
    if (!validator.matches(confirmPassword, password)) {
      errors.confirmPassword = "Confirmation password do not match.";
    }
    if (!phone_number || !trim(phone_number)) {
      errors.phone_number = "Please enter your phone number.";
    } else if (!validator.isMobilePhone(phone_number)) {
      errors.phone_number = "Please enter a valid phone number.";
    }

    if (!country || !trim(country)) {
      errors.country = "Please choose your country.";
    }

    if (!province || !trim(province)) {
      errors.province = "Please choose your province.";
    }

    return errors;
  };

  useEffect(() => {
    CountryList();
  }, []);
  useEffect(() => {
    if (country) {
      StateList();
    }
  }, [country]);

  const CountryList = async () => {
    // setLoading(true);

    axios
      .get(`/global/countries`)
      .then((response) => {
        setLoading(false);
        if (response?.data) {
          setCountryList(response.data);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  const StateList = () => {
    // setLoading(true);
    axios
      .post("global/province", { state_id: country })
      .then((response) => {
        setLoading(false);
        if (response.data) {
          setStateList(response.data);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const handleData = (e) => {
    const { value } = e.target;
    setRegisterData({ ...registerData, [e.target.name]: value });

    setErrorMessage("");
  };
  // const SubmitHandler = (value) => {
  //   setLoading(true);
  //   axios
  //     .post("/register", value)
  //     .then(function (response) {
  //       setLoading(false);
  //       if (response.status === 200) {
  //         route("/");
  //       } else if (response.status === 201) {
  //         setBackendmsg(response.data.errMsg);
  //       }
  //     })
  //     .catch(function (error) {
  //       setLoading(false);
  //      
  //     });
  // };
  const SubmitHandler = (e) => {
    e.preventDefault();
    const Valid = validation();
    if (Valid && Object.keys(Valid)?.length === 0) {
      setErrorMessage("");
      setLoading(true);
      axios
        .post("/register", registerData)
        .then(function (response) {
          setLoading(false);
          if (response.status === 200) {
            notify("Registration successful", "success");
            route("/");
          } else if (response.status === 201) {
            setBackendmsg(response.data.errMsg);
          }
        })
        .catch(function (error) {
          setLoading(false);
  
        });
    } else {
      setErrorMessage(Valid);
    }
  };

  return (
    <>
      <Navbar />
      {loading && <Loader />}
      <div className="dashboard-main d-flex justify-content-center px-xl-5 px-md-3 py-xl-5 py-md-3 overflow-auto w-100">
        <div className="register_form custom__form-a">
          <form action="" className="form-area signup-form">
            <h1 className="mb-xl-5 mb-lg-4 mb-md-3 text-center">Sign Up</h1>
            <div className="row gy-4 gx-4">
              <div className="col-lg-4">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    First Name <span className="must-field">*</span>
                  </label>
                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={first_name}
                    name="first_name"
                    id="first_name"
                    className={`form-control frm-gp1`}
                    placeholder={`First Name`}
                  />
                  {errorMessage?.first_name && (
                    <div
                      className="error error-message"
                      style={{ color: "red" }}
                    >
                      {errorMessage?.first_name}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Middle Name
                  </label>
                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={middle_name}
                    name="middle_name"
                    id="middle_name"
                    className={"form-control frm-gp1"}
                    placeholder={`Middle Name`}
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Last Name <span className="must-field">*</span>
                  </label>
                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={last_name}
                    name="last_name"
                    id="last_name"
                    className={"form-control frm-gp1"}
                    placeholder={`Last Name`}
                  />
                  {errorMessage?.last_name && (
                    <div
                      className="error error-message"
                      style={{ color: "red" }}
                    >
                      {errorMessage?.last_name}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Username <span className="must-field">*</span>
                  </label>

                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={username}
                    name="username"
                    id="username"
                    className={"form-control frm-gp1"}
                    placeholder={`Username`}
                  />
                  {errorMessage?.username && (
                    <div
                      className="error error-message"
                      style={{ color: "red" }}
                    >
                      {errorMessage?.username}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Email <span className="must-field">*</span>
                  </label>

                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={email}
                    name="email"
                    className={"form-control frm-gp1"}
                    placeholder={`Email`}
                  />
                  {errorMessage?.email && (
                    <div
                      className="error error-message"
                      style={{ color: "red" }}
                    >
                      {errorMessage?.email}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Password <span className="must-field">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      onChange={(e) => handleData(e)}
                      type={password_type}
                      value={password}
                      name="password"
                      className={"form-control frm-gp1"}
                      placeholder={`Password`}
                    />
                    {errorMessage?.password && (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.password}
                      </div>
                    )}
                    <div
                      className="position-absolute top-50 start-100 translate-middle pe-5"
                      onClick={() => {
                        setRegisterData({
                          ...registerData,
                          password_type:
                            registerData.password_type == "text"
                              ? "password"
                              : "text",
                        });
                      }}
                    >
                      {password_type == "text" ? (
                        <AiOutlineEye />
                      ) : (
                        <AiOutlineEyeInvisible />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Confirm Password <span className="must-field">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      onChange={(e) => handleData(e)}
                      type={confirmPassword_type}
                      value={confirmPassword}
                      name="confirmPassword"
                      className={"form-control frm-gp1"}
                      placeholder={`Confirm Password`}
                    />
                    {errorMessage?.confirmPassword && (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.confirmPassword}
                      </div>
                    )}
                    <div
                      className="position-absolute top-50 start-100 translate-middle pe-5"
                      onClick={() => {
                        setRegisterData({
                          ...registerData,
                          confirmPassword_type:
                            confirmPassword_type == "text"
                              ? "password"
                              : "text",
                        });
                      }}
                    >
                      {confirmPassword_type == "text" ? (
                        <AiOutlineEye />
                      ) : (
                        <AiOutlineEyeInvisible />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Phone Number <span className="must-field">*</span>
                  </label>

                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={phone_number}
                    name="phone_number"
                    className={"form-control frm-gp1"}
                    placeholder={`Phone number`}
                  />
                  {errorMessage?.phone_number && (
                    <div
                      className="error error-message"
                      style={{ color: "red" }}
                    >
                      {errorMessage?.phone_number}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Country <span className="must-field">*</span>
                  </label>
                  <div className="position-relative">
                    <select
                      value={country}
                      name="country"
                      onChange={(e) => handleData(e)}
                      className={`form-control frm-gp1`}
                      placeholder={`Country`}
                    >
                      <option value="">Choose Country</option>
                      {countryList?.map((items, i) => {
                        return (
                          <option key={i} value={items.id}>
                            {items.country_name}
                          </option>
                        );
                      })}
                    </select>
                    {errorMessage?.country && (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.country}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Province <span className="must-field">*</span>
                  </label>
                  <div className="position-relative">
                    <select
                      value={province}
                      name="province"
                      onChange={(e) => handleData(e)}
                      className={`form-control frm-gp1 `}
                      placeholder={`Province`}
                    >
                      <option value="">Choose Province</option>
                      {stateList?.map((items, i) => {
                        return (
                          <option key={i} value={items.id}>
                            {items?.province_name}
                          </option>
                        );
                      })}
                    </select>
                    {errorMessage?.province && (
                      <div
                        className="error error-message"
                        style={{ color: "red" }}
                      >
                        {errorMessage?.province}
                      </div>
                    )}
                  </div>
                </div>
              </div>{" "}
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    City
                  </label>

                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={city}
                    name="city"
                    className={"form-control frm-gp1"}
                    placeholder={`city`}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Postal code
                  </label>
                  <div className="position-relative">
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={postal_code}
                      name="postal_code"
                      className={"form-control frm-gp1"}
                      placeholder={`postal code`}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Apartment
                  </label>
                  <div className="position-relative">
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={apartment}
                      name="apartment"
                      className={"form-control frm-gp1"}
                      placeholder={`apartment`}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Address
                  </label>

                  <input
                    onChange={(e) => handleData(e)}
                    type="text"
                    value={address}
                    name="address"
                    className={"form-control frm-gp1"}
                    placeholder={`address`}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Company name
                  </label>
                  <div className="position-relative">
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={company_name}
                      name="company_name"
                      className={"form-control frm-gp1"}
                      placeholder={`company name`}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="" className="form-lbl">
                    Payment Details
                  </label>
                  <div className="position-relative">
                    <input
                      onChange={(e) => handleData(e)}
                      type="text"
                      value={payment_details}
                      name="payment_details"
                      className={"form-control frm-gp1"}
                      placeholder={`Payment details`}
                    />
                  </div>
                </div>
              </div>
              {error ? (
                <p className="col-span-2 text-m text-center text-red-500">
                  {error}
                </p>
              ) : null}
              {backendmsg ? (
                <div className="col-xl-12 mt-2 ">
                  <b className=" text-m bg-red-50 block text-center p-4 rounded border border-danger text-danger">
                    {backendmsg}
                  </b>
                </div>
              ) : null}
              <div>
                <button
                  type="submit"
                  className="btn btn-primary btn-lg login-btn w-100 mt-xl-3 mt-2"
                  onClick={(e) => {
                    SubmitHandler(e);
                  }}
                >
                  Register
                </button>
              </div>
              <div className="back-btn text-center">
                <Link
                  to="/"
                  className="account-text2 d-flex align-items-center justify-content-center"
                >
                  <BsArrowLeft className=" m-0 me-2" color="#0064BB" />
                  Back To Login
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
